/**
 * deriveDeviceClass — classify a client device into a coarse enum
 * for signal-emit telemetry. Pure module — extracted per
 * feedback_extract_to_lib_for_testability.md (rule #3) + findings-queue
 * row #11 refinement: lib/signal.js is "use client" tagged with React
 * imports; vitest can't parse it for hermetic tests.
 *
 * Threshold model (matches Tailwind / common breakpoints):
 *   viewport ≤ 640px → "mobile"
 *   641-1024px       → "tablet" (UNLESS userAgent says mobile, which wins)
 *   > 1024px         → "desktop" (UNLESS userAgent says mobile, which wins)
 *
 * UA-mobile override exists because viewport-only classification mislabels
 * mobile devices in landscape (e.g., iPhone 14 Pro Max landscape = 932px,
 * which would read as tablet). UA hint corrects.
 *
 * @param {number} viewportWidth - typically window.innerWidth at emit time
 * @param {string} [userAgent] - typically navigator.userAgent
 * @returns {"mobile" | "tablet" | "desktop"}
 */
export function deriveDeviceClass(viewportWidth, userAgent) {
  const uaMobile = typeof userAgent === "string" && /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
  if (uaMobile) return "mobile";
  if (typeof viewportWidth !== "number" || viewportWidth <= 0) return "desktop";
  if (viewportWidth <= 640) return "mobile";
  if (viewportWidth <= 1024) return "tablet";
  return "desktop";
}
